import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { ConstrainedContent } from "../layout/ConstrainedContent";

const useClasses = makeStyles({
  skeletonRow: {
    marginBottom: tokens.spacingVerticalM,
  },
  skeletonHeader: {
    marginBottom: tokens.spacingVerticalM,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  skeletonButton: {
    width: "110px",
  },
  skeletonSearch: {
    width: "300px",
  },
  skeletonQuickEdit: {
    width: "150px",
    marginRight: "10px",
  },
  headerRight: {
    display: "flex",
    flexDirection: "row",
  },
});

export const DraftListSkeleton = () => {
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <ConstrainedContent>
      <Skeleton aria-label={t("loading")}>
        <div className={classes.skeletonHeader}>
          <SkeletonItem
            className={classes.skeletonButton}
            shape="rectangle"
            size={40}
          />
          <div className={classes.headerRight}>
            <SkeletonItem
              className={classes.skeletonQuickEdit}
              shape="rectangle"
              size={40}
            />
            <SkeletonItem
              className={classes.skeletonSearch}
              shape="rectangle"
              size={40}
            />
          </div>
        </div>
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
      </Skeleton>
    </ConstrainedContent>
  );
};
